import React, { SVGProps } from 'react';

export const Portrait = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="24"
    height="24"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <g transform="rotate(-90 12 12)">
      <path
        fill="currentColor"
        d="M23.39 12c0 7.88-1.433 8.4-11.4 8.4-8.513 0-10.8-.38-11.286-5.4h1.752c.28 3.438 1.758 3.6 9.534 3.6 9.6 0 9.6-.247 9.6-6.6s0-6.6-9.6-6.6c-7.776 0-9.253.162-9.534 3.6H.704C1.19 3.98 3.477 3.6 11.99 3.6c9.968 0 11.4.52 11.4 8.4"
      />
      <path
        fill="currentColor"
        d="m6.3 8.76 2.551 2.34H.6v1.8h8.251L6.3 15.24l1.24 1.305L12.412 12 7.54 7.455z"
      />
    </g>
  </svg>
);
